'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

interface SearchInteractionContextType {
  hoveredEuId: string | null;
  setHoveredEuId: (id: string | null) => void;
  selectedEuId: string | null;
  setSelectedEuId: (id: string | null) => void;
}

const SearchInteractionContext = createContext<SearchInteractionContextType | undefined>(undefined);

export function SearchInteractionProvider({ children }: { children: ReactNode }) {
  const [hoveredEuId, setHoveredEuId] = useState<string | null>(null);
  const [selectedEuId, setSelectedEuId] = useState<string | null>(null);

  return (
    <SearchInteractionContext.Provider value={{ hoveredEuId, setHoveredEuId, selectedEuId, setSelectedEuId }}>
      {children}
    </SearchInteractionContext.Provider>
  );
}

export function useSearchInteraction() {
  const context = useContext(SearchInteractionContext);
  if (context === undefined) {
    throw new Error('useSearchInteraction must be used within a SearchInteractionProvider');
  }
  return context;
}
